export const base = 'file-export-pj';

// export const getQueryODATA = `${baseODATA}/fileexportsearchquery`;
export const fileExportPj = `${base}/create-file-export`;
export const deleteFileExportPjById = `${base}/delete-file-export`;
export const getAllDataFileExportPj = `${base}/get-file-export-pj`;
export const downloadExportFilePj = `${base}/download`;
